import api from './api';
import { Exercise } from '../types';

class ExerciseService {
  async getExercises(): Promise<Exercise[]> {
    const response = await api.get('/exercises/');
    // Handle both array and paginated response
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data.results) {
      return response.data.results;
    }
    return [];
  }

  async getExercise(id: number): Promise<Exercise> {
    const response = await api.get<Exercise>(`/exercises/${id}/`);
    return response.data;
  }

  async createExerciseFromPattern(patternId: number): Promise<Exercise> {
    const response = await api.post<Exercise>(`/exercise-patterns/${patternId}/generate_exercise/`);
    return response.data;
  }

  async updateExercise(id: number, data: Partial<Exercise>): Promise<Exercise> {
    const response = await api.patch<Exercise>(`/exercises/${id}/`, data);
    return response.data;
  }

  async deleteExercise(id: number): Promise<void> {
    await api.delete(`/exercises/${id}/`);
  }

  getCompilePdfUrl(id: number): string {
    const token = localStorage.getItem('token');
    return `${api.defaults.baseURL}/exercises/${id}/compile_pdf/?token=${token}`;
  }

  async reorderExercises(items: Array<{id: number, order: number, container?: number | null}>): Promise<void> {
    await api.post('/exercises/reorder/', { items });
  }

  async adoptPublicExercise(id: number): Promise<Exercise> {
    const response = await api.post<Exercise>(`/exercises/${id}/adopt/`);
    return response.data;
  }

  async duplicateExercise(id: number): Promise<Exercise> {
    const response = await api.post<Exercise>(`/exercises/${id}/duplicate/`);
    return response.data;
  }

  async getPublicExercises(): Promise<Exercise[]> {
    const response = await api.get('/exercises/available/');
    // Handle both array and paginated response
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data.results) {
      return response.data.results;
    }
    return [];
  }
}

const exerciseService = new ExerciseService();
export default exerciseService;